// extracted by mini-css-extract-plugin
module.exports = {"layoutColumns":"SrUtilityProfitAdminProcessActivationPage--layoutColumns--2GZGa","highlightYellowFadeIn":"SrUtilityProfitAdminProcessActivationPage--highlightYellowFadeIn--28DSi"};